import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { EventsService, UtilService } from '../../../shared/services';
import { IStoryDescription } from 'src/app/shared/models/fundraiser.model';

@Component({
  selector: 'app-story-tab',
  templateUrl: './story-tab.component.html',
  styleUrls: ['./story-tab.component.scss']
})
export class StoryTabComponent implements OnInit {
  isMobile: any;
  @Input() public storyDescription: IStoryDescription;
  isShown = false;
  @ViewChild('showMore') showMore: ElementRef;
  @ViewChild('aboutContainer', { static: true }) aboutContainer: ElementRef<HTMLElement>;
  constructor(
    public utilService: UtilService,
    public events: EventsService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }
  /**Toggle the shadow effect */
  toggleClass() {
    const el: HTMLElement = this.showMore.nativeElement;
    const el1: HTMLElement = this.aboutContainer.nativeElement;
    el.classList.remove('show-more-effect');
    el1.classList.add('animate-container');
    this.isShown = true;
    // this.events.sendSystemEvent({eventName: 'Story_readmore'}).subscribe(_ => _);
  }

}
